<!-- NOTICES -->
<template>
    <v-row no-gutters class="fill-height">
        <!-- // * LEFT PANEL -->
        <v-col :cols="GET_panelLayout.leftPanel">
            <v-row class="pa-0 ma-0">
                <v-col cols="12" class="d-flex align-center black">
                    <div class="font-weight-bold pl-2 white--text ">When all documents have been submitted, please submit the project for review</div>
                    <v-spacer />
                    <div>
                        <appbutton v-if="!project.reviewStatus || project.reviewStatus !== 'sent'" label="Submit project for review" icon="icons8-email-send" @click.native="sendDocs(project)" />
                        <appbutton v-else-if="project.reviewStatus === 'sent'" label="Project Submitted for Review" icon="icons8-email-send" disabled />
                    </div>
                </v-col>
            </v-row>
            <v-row class="px-2 mt-2 pa-0" dense>
                <!-- // * DESCRIPTION -->
                <v-col :cols="computedCols">
                    <v-row no-gutters class="">
                        <v-col class="px-2" cols="12" >
                            <app-text category="content-title">{{ $t(`${langPath}.title`) }} <v-icon class="ml-2" @click="MIX_help(GET_help)">icons8-help</v-icon></app-text> <!-- <v-spacer /> <v-btn v-if="$vuetify.breakpoint.mdAndUp" depressed color="secondary" class="ml-2" @click="MIX_go('/projects')">{{ $t(`buttons.backToProjects`) }}</v-btn> -->
                            <app-text class="help-text" v-if="GET_help && GET_currentUser.userType === 'CONTRACTOR'" v-html="$t(`${langPath}.text.contractor`)"></app-text>
                            <app-text class="help-text" v-if="GET_help && GET_currentUser.userType !== 'CONTRACTOR'" v-html="$t(`${langPath}.text.default`)"></app-text>    
                                                             
                        </v-col>
                    </v-row>
                </v-col>
                <!-- // * FILTERS -->
                <v-col :cols="computedCols" class="pl-2 pr-1">
                    <v-row dense>
                        <v-col cols="12" xs="12" sm="12" md="4" class="">
                            <v-text-field background-color="white" v-model="search" prepend-inner-icon="icons8-search" filled dense :label="$t(`filters.search`)" clearable hide-details></v-text-field>
                        </v-col>
                        <v-col cols="12" xs="12" sm="12" md="4" class="" v-if="$vuetify.breakpoint.lgAndUp">
                            <v-select :menu-props="{ top: false, offsetY: true }" :attach="true" background-color="white" v-model="filter.type" :items="documentTypes" item-text="text" item-value="value" filled dense clearable :label="$t(`filters.type`)" hide-details></v-select>
                        </v-col>
                        <v-col cols="12" xs="12" sm="12" md="4" class="d-flex align-center" v-if="$vuetify.breakpoint.lgAndUp">
                            <v-select :menu-props="{ top: false, offsetY: true }" :attach="true" background-color="white" v-model="sortBy" :items="filteredHeaders" item-text="text" item-value="value" filled clearable dense :label="$t(`filters.sortBy`)" hide-details>
                                <template v-slot:item="data">{{ $t(`fields.${data.item.text}`) }}</template>
                                <template v-slot:selection="data">{{ $t(`fields.${data.item.text}`) }}</template>
                            </v-select>
                            <v-btn icon class="ml-2" @click="filter.sortAsc = !filter.sortAsc"><v-icon :class="{ 'icons8-down-arrow': filter.sortAsc, 'icons8-up-arrow': !filter.sortAsc }" class="text-h5"></v-icon></v-btn>
                        </v-col>
                    </v-row>
                    <!-- <v-row dense class="justify-end align-end">
                        <div class=""><appbutton label="ALL DOCS SUBMITTED" icon="icons8-email-send" type="secondary" iconclass="white--text" class="pt-2" labelclass="white--text" showlabel="xlOnly" /></div>
                    </v-row> -->
                </v-col>
            </v-row>
            <v-row class="px-2 mt-2 pa-0" dense>
                <!-- // * Filter and Button Row -->
                <v-col cols="12" class="pl-2 pa-0 d-flex align-center">
                    <!-- // * STATUS FILTER (CUSTOM) -->
                    <div>
                        <v-btn-toggle v-model="filter.status" multiple color="white" active-class="white" background-color="lightgrey" dense >
                          <v-btn value="APPROVED"><v-icon class="success--text icons8-checkmark-yes"></v-icon><span v-if="$vuetify.breakpoint.lgAndUp" class="success--text caption">{{$t('filters.approved')}}</span></v-btn>
                          <v-btn value="REJECTED"><v-icon class="warning--text icons8-high-importance"></v-icon><span v-if="$vuetify.breakpoint.lgAndUp" class="warning--text caption">{{$t('filters.rejected')}}</span></v-btn>
                          <v-btn value="PENDING"><v-icon class="grey--text icons8-circle"></v-icon><span v-if="$vuetify.breakpoint.lgAndUp" class="grey--text caption">{{$t('filters.pending')}}</span></v-btn>
                          <v-btn value="DRAFT"><v-icon class="grey--text text--lighten-1 icons8-inactive-state"></v-icon><span v-if="$vuetify.breakpoint.lgAndUp" class="grey--text caption">{{$t('filters.draft')}}</span></v-btn>
                        </v-btn-toggle>
                    </div>
                    <!-- // * SHOW DELETED -->
                        <div class="d-flex" v-if="$vuetify.breakpoint.mdAndUp">
                            <v-icon class="ml-4 purple--text text-h4">icons8-trash</v-icon>
                            <v-switch @change="getTableData()" v-model="showDeleted" class="ml-1 purple--text" inset color="purple"></v-switch>                                            
                        </div>
                    <v-spacer></v-spacer>
                    <!-- // * BUTTONS -->
                    <div><appbutton :label="$t('buttons.add')" icon="icons8-document" type="secondary" iconclass="white--text" labelclass="white--text" showlabel="xlOnly" @click.native="openItem('', project, 'New', false)" /></div>
                    <div><appbutton v-if="$vuetify.breakpoint.lgAndUp" :label="$t('buttons.columns')" icon="icons8-select-column" class="mr-1" type="secondary" iconclass="white--text" labelclass="white--text" showlabel="2xlOnly" @click.native="columnsDialog = true" /></div>
                    <!-- <div><appbutton v-if="$vuetify.breakpoint.lgAndUp" :label="$t('buttons.export')" icon="icons8-export-csv" type="secondary" iconclass="white--text" labelclass="white--text" showlabel="2xlOnly" @click.native="mix_exportDocuments" /></div> -->
                </v-col>
                <!-- // * Table -->
                <v-col class="px-2 tabledata" v-if="$vuetify.breakpoint.mdAndUp" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                    <v-data-table
                        :headers="filteredHeaders"
                        :items-per-page="MIX_itemsPerPage(MIX_breakpoint())"
                        :items="computedTableData"
                        item-key="id"
                        class="elevation-0"
                        hide-default-header
                        :search="search"
                        >
                        <!-- // HEADERS (GENERIC) -->                        
                        <template v-slot:header="{ props }">
                            <th :align="head.align" class="pa-4 font-weight-medium" style="font-size:12px !important;" v-for="(head, index) in props.headers" :key="index">
                                {{ $t(`fields.${head.text}`) }}
                            </th>
                        </template>     
                        <!-- // STATUS (CUSTOM) -->             
                        <template v-slot:[`item.documentStatus`]="{ item }">
                            <v-icon v-if="item.documentStatus === 'APPROVED'" :style="{'background-image': 'url(' + require('@/assets/circle.svg') + ')'}" class="iconbackground display-1 success--text icons8-checkmark-yes"></v-icon>
                            <v-icon v-if="item.documentStatus === 'REJECTED'" :style="{'background-image': 'url(' + require('@/assets/circle.svg') + ')'}" class="iconbackground display-1 warning--text icons8-high-importance"></v-icon>
                            <v-icon v-if="item.documentStatus === 'PENDING'" :style="{'background-image': 'url(' + require('@/assets/circle.svg') + ')'}" class="iconbackground display-1 grey--text icons8-circle"></v-icon>
                            <v-icon v-if="item.documentStatus === 'DRAFT'" :style="{'background-image': 'url(' + require('@/assets/circle.svg') + ')'}" class="iconbackground display-1 grey--text text--lighten-1 icons8-inactive-state"></v-icon>
                        </template>
      
                        <!-- // NAME (CUSTOM) -->
                        <template v-slot:[`item.documentName`]="{ item }">
                            <span v-if="item.delete !== null && item.delete !== '' && item.delete !== undefined" class="purple--text d-inline-block text-truncate" style="max-width: 200px;"><v-icon class="purple--text">icons8-trash</v-icon> {{ item.documentName}}</span>
                            <span v-else class="d-inline-block text-truncate" style="max-width: 200px;">{{ item.documentName }}</span>
                        </template>

                        <!-- // DOCUMENT TYPE -->
                        <template v-slot:[`item.documentType`]="{ item }">
                            {{ lookupField('documentTypes', 'text', item.documentType)  }}
                        </template>

                        <!-- // PROJECT (CUSTOM)) -->
                        <template v-slot:[`item.project`]="{ item }">
                            {{ item.project.projectName}}
                        </template>


                        <!-- // FILE DATA (CUSTOM)) -->
                        <template v-slot:[`item.fileData`]="{ item }">
                            <div v-if="item.fileData !== null">
                                <!-- // TODO MORE FILE TYPES REQUIRED -->
                                <v-icon @click="openItem(item.id, project, 'View', false)" v-if="item.fileData.fileType === 'image/png' || item.fileData.fileType === 'image/jpeg'" class="text-h4 grey--text text--darken-2">icons8-image-document</v-icon>
                                <v-icon @click="openItem(item.id, project, 'View', false)" v-else-if="item.fileData.fileType === 'application/pdf'" class="text-h4 red--text text--darken-2">icons8-pdf</v-icon>
                                <v-icon @click="openItem(item.id, project, 'View', false)" v-else-if="item.fileData.fileType === 'video/mp4'" class="text-h4 grey--text text--darken-2">icons8-circled-play</v-icon>
                                <v-icon @click="openItem(item.id, project, 'View', false)" v-else-if="item.fileData.fileType === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'" class="text-h4 blue--text text--darken-3">icons8-microsoft-word</v-icon>
                                <v-icon @click="openItem(item.id, project, 'View', false)" v-else-if="item.fileData.fileType === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'" class="text-h4 green--text text--darken-3">icons8-microsoft-excel</v-icon>
                                <v-icon @click="openItem(item.id, project, 'View', false)" v-else-if="item.fileData.fileType === 'application/vnd.openxmlformats-officedocument.presentationml.presentation'" class="text-h4 red--text text--darken-3">icons8-microsoft-powerpoint</v-icon>
                                <v-icon @click="openItem(item.id, project, 'View', false)" v-else>icons8-file</v-icon>
                            </div>
                        </template>

                        <!-- // ACTION (GENERIC) -->
                        <template v-slot:[`item.actions`]="{ item }">
                            <v-btn @click="openItem(item.id, project, 'View', false)" depressed class="black--text white">Open<v-icon>mdi-chevron-right</v-icon></v-btn>
                        </template>


                        <!-- // CREATED USER DATA (GENERIC) -->
                        <template v-slot:[`item.createdUserData`]="{ item }">
                            <div v-if="item.createdUserData !== '' && item.createdUserData !== undefined && item.createdUserData !== null" @click="MIX_popupUser(item.createdUserData.userId)" class="pointer noselect fixedcolumn">
                                <v-icon>icons8-identification-documents</v-icon>      
                                {{ item.createdUserData.userName }}
                            </div>
                        </template>                                                        
                        <!-- // MODIFIED USER DATA (GENERIC) -->
                        <template v-slot:[`item.modifiedUserData`]="{ item }">
                            <div v-if="item.modifiedUserData !== '' && item.modifiedUserData !== undefined && item.modifiedUserData !== null" @click="MIX_popupUser(item.modifiedUserData.userId)" class="pointer noselect fixedcolumn">
                                <v-icon>icons8-identification-documents</v-icon>      
                                {{ item.modifiedUserData.userName }}
                            </div>
                        </template>
                        <!-- // DELETE USER DATA (GENERIC) -->
                        <template v-slot:[`item.deleteUserData`]="{ item }">
                            <div v-if="item.deleteUserData !== '' && item.deleteUserData !== undefined && item.deleteUserData !== null" @click="MIX_popupUser(item.deleteUserData.userId)" class="pointer noselect fixedcolumn">
                                <v-icon>icons8-identification-documents</v-icon>      
                                {{ item.deleteUserData.userName }}
                            </div>
                        </template>
                    </v-data-table>
                </v-col>
                <!-- // * MOBILE CARDS / Instead of Table -->
                <v-col class="px-2 tabledata" v-if="$vuetify.breakpoint.smAndDown" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                    <v-row no-gutters>
                        <v-col cols="12" xs="12" class="my-1 pa-1 white tablecard" v-for="item in computedTableData" :key="item.id" @click="openItem(item.id, project, 'View', false)">
                            <v-row class="d-flex align-center justify-center pa-3 fill-height" no-gutters >
                                <v-col cols="2" class="">
                                    <!-- // TODO MEED TO MAKE THIS GENERIC -->
                                    <v-icon v-if="item.documentStatus === 'APPROVED'" :style="{'background-image': 'url(' + require('@/assets/circle.svg') + ')'}" class="iconbackground display-1 success--text icons8-checkmark-yes"></v-icon>
                                    <v-icon v-if="item.documentStatus === 'REJECTED'" :style="{'background-image': 'url(' + require('@/assets/circle.svg') + ')'}" class="iconbackground display-1 warning--text icons8-high-importance"></v-icon>
                                    <v-icon v-if="item.documentStatus === 'PENDING'" :style="{'background-image': 'url(' + require('@/assets/circle.svg') + ')'}" class="iconbackground display-1 grey--text icons8-circle"></v-icon>
                                    <v-icon v-if="item.documentStatus === 'DRAFT'" :style="{'background-image': 'url(' + require('@/assets/circle.svg') + ')'}" class="iconbackground display-1 grey--text text--lighten-1 icons8-inactive-state"></v-icon>
                                </v-col>
                                <v-col cols="7" class="d-flex flex-column">
                                    <div style="margin: 0px !important; line-height: 20px !important;" class="noselect"><span class="d-inline-block text-truncate" style="max-width: 200px;">{{ item.documentName }}</span></div>
                                    <div style="" class="font-weight-bold caption grey--text text--darken-1 noselect">{{ lookupField('documentTypes', 'text', item.documentType) }}</div>
                                    <div class="caption noselect">{{ MIX_formatDateTime(item.createdDateTime, 'DD-MMM-YY HH:mm', 'DD-MMM-YY') }}</div>
                                </v-col>
                                <v-col cols="3" class="text-right"><v-icon @click="openItem(item.id, project, 'View', false)">mdi-chevron-right</v-icon></v-col>
                            </v-row>
                         </v-col>
                    </v-row>
                </v-col>
                <!-- // * COPYRIGHT -->
                <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="px-0 copyright">
                    <appcopyright  />
                </v-col>
            </v-row>
        </v-col>
        <!-- // * RIGHT PANEL -->
        <!-- // * DYNAMIC COMPONENT PANEL -->
        <transition
            name="custom-classes-transition"
            enter-active-class="animate__animated animate__fadeIn animate__faster"
            leave-active-class="animate__animated animate__fadeOut animate__faster"
            mode="out-in">
            <rightpanel></rightpanel>
        </transition>
        <!-- // * DYNAMIC COMPONENT DIALOG -->        
        <v-dialog v-model="columnsDialog" scrollable max-width="300px">
            <v-card>
                <v-card-title>{{$t('miscHeadings.showHideColumns')}}</v-card-title>
                <v-divider></v-divider>
                <v-card-text style="height: 300px;">
                    <v-list>
                        <v-list-item v-for="(header, index) in columnHeaders" :key="index">
                          <v-list-item-title><v-checkbox color="grey darken-1" hide-details v-model="headers[index].hidden" :false-value="true" :true-value="false" :label="$t(`fields.${header.text}`)"></v-checkbox></v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions class="text-right">
                    <v-spacer />
                    <v-btn color="primary" text @click="columnsDialog = false">Close</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>        
    </v-row>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'; // Map Actions / Getters
    export default {
        // * DATA
        data: () => ({
            collection: 'documents',
            collectionTitle: 'Documents',
            collectionItem: 'document',
            collectionItemTitle: 'Document',  
            langPath: 'project.projectPage.documents',
            columnsDialog: false,
            search: '', // Table Search
            sortBy: 'documentName', // Default Table Sort By
            customWhere: [],
            filter: {
                // Default Filters
                sortAsc: true,
                status: ['APPROVED', 'REJECTED', 'PENDING', 'DRAFT'],
                type: '',
            },
            tableData: [], // Table Data
            headers: [
                { text: 'status', value: 'documentStatus', sortable: false, align: 'center', hidden: false, hide: false },
                { text: 'id', value: 'id', sortable: false, align: 'left', hidden: true, hide: true },
                { text: 'name', value: 'documentName', align: 'left', sortable: false, hidden: false, hide: false },
                { text: 'type', value: 'documentType', align: 'left', sortable: false, hidden: false, hide: false },
                { text: 'project', value: 'project', align: 'left', sortable: false, hidden: false, hide: false },
                { text: 'fileData', value: 'fileData', align: 'left', sortable: false, hidden: false, hide: false },
                { text: 'created', value: 'createdDateTime', align: 'left', sortable: false, hidden: false, hide: false },
                { text: 'createdUserData', value: 'createdUserData', align: 'left', sortable: false, hidden: false, hide: true },
                { text: 'modified', value: 'modifiedDateTime', align: 'left', sortable: false, hidden: true, hide: true },
                { text: 'modifiedUserData', value: 'modifiedUserData', align: 'left', sortable: false, hidden: true, hide: true },
                { text: 'actions', value: 'actions', align: 'right', sortable: false, sortable: false, hidden: false,  hide: false },
            ],
            openedDocument: [],
            documentTypes: [],
            // DELETED
            showDeleted: false,
            project: {},
            filteredHeaders: []
            
        }),
        // * COMPUTED
        computed: {
            // Map Getters
            ...mapGetters({
                GET_panelLayout: 'GET_panelLayout',
                GET_lookupValues: 'GET_lookupValues',
                GET_project: 'GET_project',     
                GET_help: 'GET_help'           
            }),
            // COMPUTED HEADERS (GENERIC)           
            // computedHeaders() {
            //     var t = this;
            //     var headers = t.headers;
            //     return (t.$filter(headers, {
            //         hidden: false, // filter headers based on initial hidden value
            //     }));
            // },
            // Remove actions from Selectable Column Headers
            columnHeaders() {
                var t = this;
                var headers = t.headers;
                return (headers.filter((header) => {
                    return header.value !== 'actions'
                }));
            },            
            // COMPUTED COLS (GENERIC)
            computedCols() {
                var t = this;
                var cols
                var leftPanel = t.GET_panelLayout.leftPanel
                switch (true) {
                    case (leftPanel === 12): cols = 6; break
                    case (leftPanel === 6): cols = 12; break;
                    default: cols = 12;
                }
                if (t.$vuetify.breakpoint.smAndDown) { cols = 12 }
                return cols
            },
            // COMPUTED TABLE DATA (CUSTOM)
            computedTableData() {
                var t = this;
                var tableData = t.tableData;
                // Filter by Status (GENERIC)
                tableData = tableData.filter(function(item) {
                    return t.filter.status.includes(item[t.collectionItem+'Status']);
                });
                // Filter by Type (GENERIC)
                if ((t.filter.type !== '') && (t.filter.type !== undefined) && (t.filter.type !== null)) {                    
                    tableData = tableData.filter(function(item) {
                        return t.filter.type === item[t.collectionItem + 'Type'];
                    });
                }
                // Filter by Search Mobile (GENERIC)                
                if (t.search !== '' && t.$vuetify.breakpoint.smAndDown) {
                    tableData = tableData.filter(function(item) {
                        var itemName = item[t.collectionItem+'Name'].toUpperCase();
                        var search = t.search.toUpperCase();
                        return itemName.includes(search)
                    });
                }
                // Map Fields (CUSTOM)
                var tableDataList = tableData.map(e => {
                    return {
                        id: e.id,
                        documentStatus: e.documentStatus,
                        documentName: e.documentName,
                        documentDescription: e.documentDescription,
                        documentType: e.documentType,
                        project: e.project,
                        fileData: e.fileData,
                        createdDateTime: t.MIX_formatDateTime(e.createdDateTime, 'x', 'DD-MMM-YY HH:mm'),
                        createdUserData: e.createdUserData,
                        modifiedDateTime: t.MIX_formatDateTime(e.modifiedDateTime, 'x', 'DD-MMM-YY HH:mm'),
                        modifiedUserData: e.modifiedUserData,
                        delete: t.MIX_formatDateTime(e.delete, 'x', 'DD-MMM-YY HH:mm'),
                        deleteUserData: e.deleteUserData,
                    };
                });
                // Sort By (GENERIC) 
                var sortResults = t.$sortBy(tableDataList, t.sortBy)
                if (!t.filter.sortAsc) {sortResults.reverse()}
                // Return Result
                return (sortResults);      
            }
        },
        // * WATCH
        watch: {
            GET_panelLayout: {
                handler() {
                    let t = this;
                    if (t.GET_panelLayout.rightPanel === 6) {
                        t.filteredHeaders = t.headers.filter((header) => {
                            return (header.hide === false && header.hidden === false);
                        });
                    } else {
                        t.filteredHeaders = t.headers.filter((header) => {
                            return (header.hidden === false);
                        }) 
                    }
                }, deep: true,
            },
            headers: {
                handler() {
                    let t = this;
                     t.filteredHeaders = t.headers.filter((header) => {
                         return (header.hidden === false)
                     });
                }, deep: true,
            }
        },
        // * METHODS
        methods: {
            ...mapActions({'ACT_openItem': 'ACT_openDocument'}),
            // OPEN ITEM (CUSTOM)
            openItem: async function(id, project, process, popup) {
                var t = this;
                var item = {}                
                t.dynamicComponentKey++; 
                item.process = process;
                item.popup = popup;
                if (item.process !== 'New') {
                    var itemResult = await t.MIX_readDocumentById(t.collection, id)
                    item.data = itemResult.data;
                } else {
                    item.data = project;
                }
                t.ACT_openItem(item); // Open Item
                if (t.$vuetify.breakpoint.lgAndDown) {
                    t.MIX_fsDialog(true, t.collectionItemTitle, t.collectionItem);
                    t.MIX_setPanelLayout(12, 0, false, '');
                } else {
                    t.MIX_setPanelLayout(6, 6, true, t.collectionItemTitle, t.collectionItem);
                    // // * HIDE HEADERS
                    // for (var i = 0; i < t.headers.length; i++) {
                    //     if (t.headers[i].hide === true) {
                    //         t.headers[i].hidden = true;
                    //     }
                    // }
                }
                return;
            },
            async sendDocs(project) {
                return new Promise((resolve) => {
                    let t = this
                    const url = "https://europe-west2-tfw-swapp.cloudfunctions.net/sendSubmittedDocumentNotification"
                    t.$axios.post(url, project).then((response) => {
                        resolve({ code: 1, message: 'Project Submitted for Review', data: response.data, error: null })
                        t.MIX_alert(1, 'Project Submitted for Review', null, null)
                        t.updateItemStatus('sent');
                    })
                    .catch((error) => {
                        resolve({ code: -1, message: 'Account Updated', data: null, error: error.response.data.error.raw.message })
                        t.MIX_alert(-1, 'Project Not Submitted for Review', null, null)
                    })

                })
            },
            // UPDATE ITEM STATUS
            updateItemStatus: async function(status) {
                var t = this;
                // console.log('updateResult')
                var updateResult = await t.MIX_updateDocumentFieldsById ('projects', t.project.id, { 'reviewStatus': status } )
                // console.log('updateResult.code = ' + updateResult.code)
                if (updateResult.code === 1) {
                    t.MIX_alert(1, 'Status Updated', updateResult.data, null);
                    t.refreshItemView();
                } else {
                    t.MIX_alert(-1, 'ERROR - Could not update Status', null, updateResult.error);
                }
            },
            // GET TABLE DATA SNAPSHOT METHOD (GENERIC)
            getTableData: async function () {
                var t = this;
                var collection = t.$firebase.db.collection(t.collection)
                if (JSON.stringify(t.customWhere) !== '[]') {
                    for (var i = 0; i < t.customWhere.length; i++) {
                        var query = { field: t.customWhere[i].key, operator: t.customWhere[i].operator, value: t.customWhere[i].value }
                        collection = collection.where(query.field, query.operator, query.value)   
                    }
                }
                collection.onSnapshot(function(querySnapshot) {
                    t.tableData = [];
                    querySnapshot.forEach(function(doc) {
                        var document = doc.data()
                        document.id = doc.id;
                        if (!document.hasOwnProperty('delete')) {
                            t.tableData.push(document);
                        } else if (t.showDeleted) {
                            t.tableData.push(document);
                        } else {
                            // Do not Show Concern
                        }
                    });
                });
                return;
            },  
            // LOOKUP FIELD (GENERIC)
            lookupField: function(lookup, field, value) {
                var t = this;
                var lookupResult = t.$find(t[lookup], { value: value })
                if (lookupResult !== undefined) {
                    return (lookupResult)[field];
                } else {
                    return ('NOTFOUND')
                }
            }     
        },
        // * MOUNTED
        async mounted() {
            var t = this;
            // LOOKUPS (CUSTOM)
            await t.MIX_lookupValues(); // LOAD LOOKUP VALUES
            t.documentTypes = await t.GET_lookupValues('DOCUMENTTYPES');
            t.documentStatus = await t.GET_lookupValues('DOCUMENTSTATUS');
            

            var urlPath = window.location.pathname.split('/');
            // console.log(urlPath);
            var projectId = urlPath[2];

            var project = await t.MIX_readDocumentById('projects', projectId);
            t.project = project.data;
            
            // UPDATE BREADCRUMBS (CUSTOM)
            var t = this;
            var breadcrumbs = [];
            breadcrumbs.push ({ name: `Projects`, path: `/projects`}) // Set the Main Path
            breadcrumbs.push ({ name: `${t.project.projectName}`, path: `/projects/${t.project.id}/documents`}) // Set the Main Path            
            breadcrumbs.push ({ name: `${t.collectionTitle}`, path: `/projects/${t.project.id}/documents`}) // Set the Main Path
            t.MIX_breadcrumbs(breadcrumbs);
            console.log(JSON.stringify(breadcrumbs, null, 2));


            // GENERIC MOUNTED
            var t = this;
            t.MIX_setPanelLayout(12, 0, false, ''); // Hide Right Panel
            // INSERT CUSTOM WHERES HERE
            t.customWhere.push ({ key: 'project.projectId', operator: '==', value: t.project.id });
            t.getTableData(); // Get Table Data            



            // AUTO OPEN (CUSTOM)
            // * AUTO OPEN SITE IF PATH CONTAINS SITEID
            if ((window.location.pathname !== `/projects/${t.project.id}/documents` && window.location.pathname !== `/projects/${t.project.id}/documents/`)) {
                var urlPath = window.location.pathname.split('/');
                var id = urlPath[4];
                if (id === 'new') {
                    t.openItem('', 'New', false)
                } else {
                    t.openItem(id, 'View', false)
                }
            }                    
        },
    };
</script>

<style>
 .iconbackground {
    background-position: center center; 
    background-size: 80%; 
  } 

.v-data-table-header > th {
  vertical-align: bottom !important;
}
    .disabled >>> .v-input__slot::before {
        border-style: none !important;
    }

</style>
